import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-k',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-k.component.html',
  styleUrl: './section-k.component.css'
})
export class SectionKComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection13 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionKForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'family_mental',
      questionText: 'Family history of mental illness? *',
      formControlName: 'family_mental',
      infoFormControlName: 'family_mental_information',
      label: 'Please explain: *'
    },
    {
      id: 'current_events',
      questionText: 'Current events that might trigger a violent reaction (anniversary of an event, recent school shooting)? *',
      formControlName: 'current_events',
      infoFormControlName: 'current_events_information',
      label: 'Please explain: *'
    },
    {
      id: 'family_substance_abuse',
      questionText: 'Family substance abuse? *',
      formControlName: 'family_substance_abuse',
      infoFormControlName: 'family_substance_abuse_information',
      label: 'Please explain: *'
    },
    {
      id: 'frequency_mobility',
      questionText: 'Frequent mobility? *',
      formControlName: 'frequency_mobility',
      infoFormControlName: 'frequency_mobility_information',
      label: 'Please explain: *'
    },
    {
      id: 'family_instability',
      questionText: 'Family instability? *',
      formControlName: 'family_instability',
      infoFormControlName: 'family_instability_information',
      label: 'Please explain: *'
    },
    {
      id: 'lack_supervision',
      questionText: 'Lack of supervision? *',
      formControlName: 'lack_supervision',
      infoFormControlName: 'lack_supervision_information',
      label: 'Please explain: *'
    },
    {
      id: 'bully_victim',
      questionText: 'Victim of bullying? *',
      formControlName: 'bully_victim',
      infoFormControlName: 'bully_victim_information',
      label: 'Please explain: *'
    },
    {
      id: 'bully_perpetrator',
      questionText: "Perpetrator of bullying? *",
      formControlName: 'bully_perpetrator',
      infoFormControlName: 'bully_perpetrator_information',
      label: 'Please explain: *'
    },
    {
      id: 'abuse_victim',
      questionText: 'Victim of abuse and/or trauma? *',
      formControlName: 'abuse_victim',
      infoFormControlName: 'abuse_victim_information',
      label: 'Please explain: *'
    },
    {
      id: 'negative_peer',
      questionText: 'Negative peer group influence? *',
      formControlName: 'negative_peer',
      infoFormControlName: 'negative_peer_information',
      label: 'Please explain: *'
    },
    {
      id: 'antisocial_attitude',
      questionText: "Antisocial attitude? *",
      formControlName: 'antisocial_attitude',
      infoFormControlName: 'antisocial_attitude_information',
      label: 'Please explain: *'
    },
    {
      id: 'attack_encouragement',
      questionText: "Encouragement from others to carry out a plan or attack? *",
      formControlName: 'attack_encouragement',
      infoFormControlName: 'attack_encouragement_information',
      label: 'Please explain: *'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    group['k_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.k_additional_info) || this.yesNo.No, Validators.required);    
    
    this.sectionKForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionKForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionKForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionK(): void {
    if (this.sectionKForm.valid) {
      this.onSaveSection13.emit(this.sectionKForm.value);
    }
  }

}
